import { createMemo } from 'solid-js'
import { useService } from 'solid-services'
import { useChannelsReads } from './channelReads/state'
import { useChannels } from './channels/channels'

export function useSelectors() {
	const { generalChannelsResource, setupChannelsResource, unreadMessageCount } = useService(useChannels)()
	const { channelReadsResource, channelReadDictionary } = useService(useChannelsReads)()

	const lastReadFrancisUpdate = () => {
		const francisChannelId = generalChannelsResource().find(
			(channel) => channel.name === 'francis-updates',
		)?.id

		if (!francisChannelId) return

		const lastReadAt = channelReadsResource().find(
			(channel) => channel.channel_id === francisChannelId,
		)?.last_read_at

		if (!lastReadAt) return

		return { lastReadAt, francisChannelId }
	}

	const setupChannels = createMemo(() => {
		return setupChannelsResource()
			.map((channel) => {
				return {
					...channel,
					unreadCount: unreadMessageCount()[channel.id] ?? undefined,
					isSubscribed: channelReadDictionary()[channel.id]?.is_subscribed,
				}
			})
	})

	const generalChannels = createMemo(() => {
		return generalChannelsResource()
			.map((channel) => ({
				...channel,
				unreadCount: unreadMessageCount()[channel.id] ?? undefined,
				isSubscribed: channelReadDictionary()[channel.id]?.is_subscribed,
			}))
	})

	return {
		lastReadFrancisUpdate,
		setupChannels,
		generalChannels,
	}
}
